export const Colors = {
    Uluru: '#CE5127',
    UluruLight: '#E98A70',
    SeaBlue: '#27A2CC',
    SeaBlueLight: '#86CFE4',
    Sand: '#F9F4F2',
    Text: '#4B4B4B'
}
